import { render, staticRenderFns } from "./ulsemo-icon.vue?vue&type=template&id=a0a361d0&functional=true&"
import script from "./ulsemo-icon.vue?vue&type=script&lang=js&"
export * from "./ulsemo-icon.vue?vue&type=script&lang=js&"
import style0 from "./ulsemo-icon.vue?vue&type=style&index=0&id=a0a361d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports